export default __webpack_public_path__ + "static/media/getInTouch.69a8ca5b.png";